import * as React from 'react'

export const ChevronDownIcon = React.memo(
  ({ className, width='24px', height='24px', ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width={width}
          height={height}
          className={className}
          {...props} 
          viewBox="0 0 16 16" 
          fill="none">
            <path d="M8.24954 10.5574L12.536 6.1371C12.8035 5.86128 12.6413 5.33398 12.2891 5.33398H3.71614C3.36386 5.33398 3.20173 5.86128 3.4692 6.1371L7.75567 10.5574C7.89776 10.704 8.10744 10.704 8.24954 10.5574Z" fill="currentColor"/>
        </svg>
    )
  },
)

ChevronDownIcon.displayName = 'ChevronDownIcon'
